module.exports = __webpack_public_path__ + "img/by-specialization.d30c0cf1.png";